const PedidoClient = require('@/api/Operacoes/sls-pedidos.client');

export default {
  namespaced: true,
  name: 'pedidoStore',
  state: () => ({
    pedido: {
      pedidoid: null,
      tipopedidoid: null,
      estabelecimentoid: null,
      representanteid: null,
      clienteid: null,
      condicaopagamentoid: null,
      tabelaprecoid: null,
      pedidonumerocliente: null,
      pedidonumerointegracao: null,
      naturezaoperacaoid: null,
      notafiscalserie: null,
      notafiscalnumero: null,
      pedidoobservacoes: null,
      pedidoobservacoeslogistica: null,
      pedidourgente: null,
      usuarioid: null,
      unidadenegocioid: null,
      pedidodata: null,
      pedidodataentrega: null,
      pedidodataentregaprevista: null,
      pedidoentregaperiodo: null,
      pedidoobservacoesnotafiscal: null,
      pedidovalortotal: null,
      transportadoraid: null,
      prazoentrega: null,
      tipofrete: null,
      tipoenderecoid: null,
      pedidonumerorepresentante: null,
      clienteidtriangular: null,
      pedidooccliente: null,
      picid: null,
      pedidositsales: null,
      pedidositsalesdata: null,
      pedidositsalesmsg: null,
      pedidositcomercial: null,
      pedidositcomercialdata: null,
      pedidositcomercialmsg: null,
      pedidositcredito: null,
      pedidositcreditodata: null,
      pedidositcreditomsg: null,
      pedidosaldocancelado: null,
      tabelaprecoiniciovalidade: null,
      pedidoconsumidorfinal: null,
      pedidoalteradoerp: null,
      pedidoalteradoerpusuario: null,
      pedidoalteradoerpdata: null,
      tipousuariopendente: null,
      usuarioidaprovador: null,
      pedidoprioridade: null,
      canalvendaid: null,
      pedidostatusworkflow: null,
      tipoenderecoidtriangular: null,
      portadorid: null,
      portadormodalidade: null,
      moedaid: null,
      cod_priori: null,
      pedidoItens: [],
      pedidoTotal: 0,
      pedidoTotalItens: 0,
    },
    currentPedidoItem: {
      pedidoid: null,
      itemid: null,
      pedidoitemseq: null,
      pedidoitemdatareserva: null,
      pedidoitemquantidade: null,
      pedidoitemprecotabela: null,
      pedidoitemtotalmercadoria: null,
      pedidoitembaseicms: null,
      pedidoitemaliquotaicms: null,
      pedidoitemvaloricms: null,
      pedidoitembaseipi: null,
      pedidoitemaliquotaipi: null,
      pedidoitemvaloripi: null,
      pedidoitembasest: null,
      pedidoitemaliquotast: null,
      pedidoitemvalorst: null,
      pedidoitemvalorfrete: null,
      pedidoitempesobruto: null,
      pedidoitempesoliquido: null,
      pedidoitemquantidadefaturada: null,
      pedidoitemquantidadesaldo: null,
      naturezaoperacaoid: null,
      usuarioidcancelamento: null,
      pedidoitemdatacancelamento: null,
      estabelecimentoidnf: null,
      notafiscalserie: null,
      notafiscalnumero: null,
      empenhoitemdivergencia: null,
      empenhoitemdivergenciamotivo: null,
      tabelaprecovlrminimo: null,
      tabelaprecovlrmaximo: null,
      embarque: null,
      dataembarque: null,
      pedidoitemsaldo: null,
      atualizasaldoestoque: null,
      pedidoitemdeposito: null,
      notafiscaldata: null,
      pedidoitemdataentrega: null,
      pedidoitemdataentregaprevista: null,
      pedidoitempercdesc: null,
      picid: null,
      pedidoitemsitcomercial: null,
      pedidoitemsitcomercialdata: null,
      pedidoitemsaldocancelado: null,
      pedidoitemprecovenda: null,
      pedidoitemaliquotaiss: null,
      pedidoitembaseiss: null,
      pedidoitemvaloriss: null,
      pedidoitemaliquotaiva: null,
      pedidoitembaseiva: null,
      pedidoitemvaloriva: null,
      pedidoitemaliquotapis: null,
      pedidoitembasepis: null,
      pedidoitemvalorpis: null,
      pedidoitemaliquotacofins: null,
      pedidoitembasecofins: null,
      pedidoitemvalorcofins: null,
      referenciaid: null,
      pedidoitemorigemks: null,
      pedidoitemorigemems: null,
      pedidoitemdescontozf: null,
      pedidoitemqtalocada: null,
      tipoped: null,
      pedidoitemprecounitario: null,
      pedidoitemaliquotaicmsreducao: null,
    },
  }),
  mutations: {
    UPDATE_ITEM_QUANTITY(state, { item, quantity }) {
      const itemIndex = state.itemsPedido.findIndex((i) => i.item_id === item.item_id
                && i.cdn_cor === item.cdn_cor
                && i.cdn_tamanho === item.cdn_tamanho);

      if (itemIndex !== -1) {
        const updatedItem = { ...state.itemsPedido[itemIndex], pedido_item_quantidade: quantity };

        updatedItem.valor_total = parseFloat(updatedItem.pedido_item_preco_unitario * quantity).toFixed(2);
        updatedItem.valorTotalComImposto = parseFloat(updatedItem.precoComImposto * quantity).toFixed(2);

        state.itemsPedido.splice(itemIndex, 1, updatedItem);
      }
    },
    SET_PEDIDO(state, pedido) {
      state.pedido = pedido;
    },
    ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO(state, product) {
      console.log('ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', product);
      const index = state.pedido.pedidoItens.findIndex((item) => item.des_tamanho === product.des_tamanho
                && item.cdn_cor === product.cdn_cor
                && item.familia_comercial_id === product.familia_comercial_id
                && item.cdn_embalag === product.cdn_embalag);
      if (index !== -1) {
        if (state.pedido.pedidoItens[index].item_pic_promocao) {
          state.pedido.pedidoItens.push(product);
        } else {
          const quantidadeAtual = Number(state.pedido.pedidoItens[index].pedido_item_quantidade || 0);
          const quantidadeNova = Number(product.pedido_item_quantidade || 0);
          state.pedido.pedidoItens[index].pedido_item_quantidade = quantidadeAtual + quantidadeNova;
        }
      } else {
        state.pedido.pedidoItens.push(product);
      }
    },
    REMOVE_PRODUCT_ITEM_PEDIDO(state, payload) {
      const index = state.pedido.pedidoItens.findIndex((item) => item.des_tamanho === payload.des_tamanho && item.cdn_cor === payload.cdn_cor);
      if (index !== -1) {
        state.pedido.pedidoItens.splice(index, 1);
      }
    },
    SET_CART_ITEMS(state, products) {
      state.cartItems = products;
    },
    REMOVER_ITEM_PIC_PROMOCAO(state) {
      state.pedido.pedidoItens = state.pedido.pedidoItens.filter((info) => !info.item_pic_promocao);
    },
  },
  getters: {
    getTotalPedidoComImposto: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + (parseFloat(item.precoComImposto || 0) * parseFloat(item.pedido_item_quantidade || 0)), 0).toFixed(2),
    getPedido: (state) => state.pedido,
    getItemPedido: (state) => state.pedido.pedidoItens,
    getTotalPedido: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + Number(item.valor_total || 0), 0),
    getTotalItensPedido: (state) => state.pedido.pedidoItens.reduce((acc, item) => acc + Number(item.pedido_item_quantidade || 0), 0),
    getLastSequenceItemPedido: (state) => {
      const lastItem = state.pedido.pedidoItens[state.pedido.pedidoItens.length - 1];
      return lastItem ? lastItem.pedido_item_seq : 0;
    },
  },
  actions: {
    clearPedidoAndItemPedido({ commit }) {
      commit('SET_PEDIDO', {
        pedidoid: null,
        tipopedidoid: null,
        estabelecimentoid: null,
        representanteid: null,
        clienteid: null,
        condicaopagamentoid: null,
        tabelaprecoid: null,
        pedidonumerocliente: null,
        pedidonumerointegracao: null,
        naturezaoperacaoid: null,
        notafiscalserie: null,
        notafiscalnumero: null,
        pedidoobservacoes: null,
        pedidoobservacoeslogistica: null,
        pedidourgente: null,
        usuarioid: null,
        unidadenegocioid: null,
        pedidodata: null,
        pedidodataentrega: null,
        pedidodataentregaprevista: null,
        pedidoentregaperiodo: null,
        pedidoobservacoesnotafiscal: null,
        pedidovalortotal: null,
        transportadoraid: null,
        prazoentrega: null,
        tipofrete: null,
        tipoenderecoid: null,
        pedidonumerorepresentante: null,
        clienteidtriangular: null,
        pedidooccliente: null,
        picid: null,
        pedidositsales: null,
        pedidositsalesdata: null,
        pedidositsalesmsg: null,
        pedidositcomercial: null,
        pedidositcomercialdata: null,
        pedidositcomercialmsg: null,
        pedidositcredito: null,
        pedidositcreditodata: null,
        pedidositcreditomsg: null,
        pedidosaldocancelado: null,
        tabelaprecoiniciovalidade: null,
        pedidoconsumidorfinal: null,
        pedidoalteradoerp: null,
        pedidoalteradoerpusuario: null,
        pedidoalteradoerpdata: null,
        tipousuariopendente: null,
        usuarioidaprovador: null,
        pedidoprioridade: null,
        canalvendaid: null,
        pedidostatusworkflow: null,
        tipoenderecoidtriangular: null,
        portadorid: null,
        portadormodalidade: null,
        moedaid: null,
        cod_priori: null,
        pedidoItens: [],
        pedidoTotal: 0,
        pedidoTotalItens: 0,
      });
      commit('SET_CURRENT_PEDIDO_ITEM', {
        pedidoid: null,
        itemid: null,
        pedidoitemseq: null,
        pedidoitemdatareserva: null,
        pedidoitemquantidade: null,
        pedidoitemprecotabela: null,
        pedidoitemtotalmercadoria: null,
        pedidoitembaseicms: null,
        pedidoitemaliquotaicms: null,
        pedidoitemvaloricms: null,
        pedidoitembaseipi: null,
        pedidoitemaliquotaipi: null,
        pedidoitemvaloripi: null,
        pedidoitembasest: null,
        pedidoitemaliquotast: null,
        pedidoitemvalorst: null,
        pedidoitemvalorfrete: null,
        pedidoitempesobruto: null,
        pedidoitempesoliquido: null,
        pedidoitemquantidadefaturada: null,
        pedidoitemquantidadesaldo: null,
        naturezaoperacaoid: null,
        usuarioidcancelamento: null,
        pedidoitemdatacancelamento: null,
        estabelecimentoidnf: null,
        notafiscalserie: null,
        notafiscalnumero: null,
        empenhoitemdivergencia: null,
        empenhoitemdivergenciamotivo: null,
        tabelaprecovlrminimo: null,
        tabelaprecovlrmaximo: null,
        embarque: null,
        dataembarque: null,
        pedidoitemsaldo: null,
        atualizasaldoestoque: null,
        pedidoitemdeposito: null,
        notafiscaldata: null,
        pedidoitemdataentrega: null,
        pedidoitemdataentregaprevista: null,
        pedidoitempercdesc: null,
        picid: null,
        pedidoitemsitcomercial: null,
        pedidoitemsitcomercialdata: null,
        pedidoitemsaldocancelado: null,
        pedidoitemprecovenda: null,
        pedidoitemaliquotaiss: null,
        pedidoitembaseiss: null,
        pedidoitemvaloriss: null,
        pedidoitemaliquotaiva: null,
        pedidoitembaseiva: null,
        pedidoitemvaloriva: null,
        pedidoitemaliquotapis: null,
        pedidoitembasepis: null,
        pedidoitemvalorpis: null,
        pedidoitemaliquotacofins: null,
        pedidoitembasecofins: null,
        pedidoitemvalorcofins: null,
        referenciaid: null,
        pedidoitemorigemks: null,
        pedidoitemorigemems: null,
        pedidoitemdescontozf: null,
        pedidoitemqtalocada: null,
        tipoped: null,
        pedidoitemprecounitario: null,
        pedidoitemaliquotaicmsreducao: null,
      });
    },
    removeProductFromCart({ commit }, productId) {
      commit('REMOVE_PRODUCT_FROM_CART', productId);
    },
  },
};
